module.exports = __webpack_public_path__ + "static/media/statistikaamet-logo.45d1d3c2.svg";